import { render, staticRenderFns } from "./ActiveJobAssignmentsPage.vue?vue&type=template&id=20fbb089&"
import script from "./ActiveJobAssignmentsPage.vue?vue&type=script&lang=js&"
export * from "./ActiveJobAssignmentsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports